export default "__VITE_ASSET__3828cbd5__"